var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5C6.885 12.5 6.7695 12.4605 6.676 12.381C6.555 12.278 3.705 9.831 2.516 7.162C2.4035 6.91 2.517 6.614 2.7695 6.502C3.021 6.39 3.317 6.503 3.4295 6.7555C4.299 8.708 6.218 10.605 6.9915 11.3205C8.3565 9.9955 11 7.0345 11 5.115C11 2.846 9.2055 1 7 1C4.7945 1 3 2.846 3 5.115C3 5.391 2.776 5.615 2.5 5.615C2.224 5.615 2 5.391 2 5.115C2 2.2945 4.243 0 7 0C9.757 0 12 2.2945 12 5.115C12 8.071 7.528 12.1945 7.3375 12.369C7.242 12.456 7.121 12.5 7 12.5Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C5.897 7 5 6.103 5 5C5 3.897 5.897 3 7 3C8.103 3 9 3.897 9 5C9 6.103 8.103 7 7 7ZM7 4C6.4485 4 6 4.4485 6 5C6 5.5515 6.4485 6 7 6C7.5515 6 8 5.5515 8 5C8 4.4485 7.5515 4 7 4Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14H0.500002C0.322002 14 0.157002 13.9055 0.0675021 13.751C-0.0219979 13.5965 -0.0224979 13.407 0.0660021 13.252L2.066 9.752C2.203 9.5125 2.5085 9.4285 2.748 9.566C2.9875 9.703 3.071 10.0085 2.934 10.248L1.3615 13H12.638L11.0655 10.248C10.9285 10.0085 11.012 9.703 11.2515 9.566C11.491 9.428 11.7965 9.5125 11.9335 9.752L13.9335 13.252C14.022 13.407 14.0215 13.5965 13.932 13.751C13.843 13.9055 13.678 14 13.5 14Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalSalesIcon);
export default __webpack_public_path__ + "static/media/local-sales-icon.2619983518e735e4aee2e8b85dd4b1cc.svg";
export { ForwardRef as ReactComponent };